import { render, staticRenderFns } from "./Fleet.vue?vue&type=template&id=6472120a"
import script from "./Fleet.vue?vue&type=script&lang=js"
export * from "./Fleet.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports